import Swiper, { Pagination } from "swiper";

const slid = document.querySelector('.swiper-topic');

if (slid) {
  let initSlider = false;
  let swiper;
  
  function swiperCard() {
    if (window.innerWidth <= 1199 && window.innerWidth > 767 ) {
      if (!initSlider) {
        initSlider = true;
        swiper = new Swiper(".swiper-topic", {
          modules:[Pagination],
          slidesPerView: 1,
          pagination: {
            el: ".day-topic-pagination",
            clickable: true,
          },
        });
      } 
    } else if (initSlider) {
      swiper.destroy();
      initSlider = false;
    }
  }
  swiperCard();
    window.addEventListener("resize", swiperCard);
}

function moveAside() {
  const element = document.querySelector("#aside-news");
  const place = document.querySelector("#day-topic");
  const aside = document.querySelector("#aside-panel");
  // const banner = document.querySelector("#banner-1");
  if (place) {
    if (window.innerWidth <= 767 ) {
      place.after(element);
      // if (banner) {
      //   place.before(banner)
      // }
    } else {
      // if(banner) {
      //   aside.prepend(banner)
      //   banner.after(element);
      // } else {
        aside.prepend(element);
      // }
    }
  }

}
moveAside();
window.addEventListener("resize", moveAside );

